"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.revertToEmptyComponent = exports.componentBuilderFactory = void 0;
const assert_never_1 = __importDefault(require("assert-never"));
const immer_1 = require("immer");
const spu_1 = require("@tencent/tccp-frontend-contract/spu");
const trade_1 = require("@tencent/tccp-frontend-contract/trade");
const component_1 = require("../types/component");
const strategy_1 = require("./strategy");
/** 根据参数列表生成组件列表 */
const componentBuilderFactory = (paramList, renderUnitList) => (effectiveRules, currentValues) => {
    var _a, _b, _c, _d, _e, _f;
    const components = [];
    for (const renderUnit of renderUnitList) {
        switch (renderUnit.type) {
            case trade_1.ParamTypeEnum.Spec:
            case trade_1.ParamTypeEnum.ExternalParameter:
            case trade_1.ParamTypeEnum.Quantity: {
                const param = paramList.find(({ paramKey }) => paramKey === renderUnit.key);
                if (!param) {
                    // 没有的情况下直接跳过（会没有么？）
                    continue;
                }
                const { SpecName: specName, SpecValueUnit: unit = '', ValueRestrictionList: valueRestrictions, } = param.spec;
                let { SpecValueType: specValueType } = param.spec;
                // 特殊处理数量、用量，他们按照整数来展示和输入
                if (renderUnit.type === trade_1.ParamTypeEnum.Quantity) {
                    specValueType = spu_1.ValueTypeEnum.Int;
                }
                const rule = effectiveRules[renderUnit.key];
                const componentDraft = (0, immer_1.createDraft)({
                    name: renderUnit.key,
                    key: renderUnit.key,
                    label: specName,
                    description: renderUnit.description,
                    type: component_1.ComponentType.Empty,
                    isField: true,
                    valueType: specValueType,
                    inputType: renderUnit.inputType,
                    unit,
                    isRequired: false,
                    isCalculable: false,
                    isStatic: false,
                    isComputed: false,
                    defaultValue: undefined,
                });
                // 默认看第一项
                const firstRestriction = valueRestrictions.at(0);
                switch (firstRestriction.RestrictionType) {
                    case spu_1.RestrictionEnum.Choice: {
                        componentDraft.type = component_1.ComponentType.Enum;
                        componentDraft.options = firstRestriction.RestrictionRuleList.map(value => ({
                            label: value.ValueName,
                            value: String(value.Value),
                        }));
                        componentDraft.defaultValue =
                            (_a = firstRestriction.RestrictionRuleList.at(0)) === null || _a === void 0 ? void 0 : _a.Value;
                        break;
                    }
                    case spu_1.RestrictionEnum.Range: {
                        const { Min: min, Max: max, Step: step, } = firstRestriction.RestrictionRuleList.at(0);
                        componentDraft.type = component_1.ComponentType.Input;
                        componentDraft.range = [min, max];
                        componentDraft.step = step;
                        componentDraft.defaultValue = min;
                        break;
                    }
                    case spu_1.RestrictionEnum.Regex: {
                        const { Regex: regexp } = firstRestriction.RestrictionRuleList.at(0);
                        componentDraft.type = component_1.ComponentType.Input;
                        componentDraft.regexp = regexp;
                        componentDraft.defaultValue = '';
                        break;
                    }
                    case spu_1.RestrictionEnum.Ref: {
                        componentDraft.type = component_1.ComponentType.Ref;
                        break;
                    }
                }
                if (rule) {
                    (0, strategy_1.compileStrategyToComponentConfig)(componentDraft, rule);
                    // 判断是否有引用单位
                    if (componentDraft.isField && rule.refUnit) {
                        const currentUnitValue = (_b = currentValues === null || currentValues === void 0 ? void 0 : currentValues[rule.refUnit]) !== null && _b !== void 0 ? _b : undefined;
                        const unitParam = paramList.find(({ paramKey }) => paramKey === rule.refUnit);
                        const currentUnitText = (_f = (_e = (_d = (_c = unitParam === null || unitParam === void 0 ? void 0 : unitParam.spec.ValueRestrictionList) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.RestrictionRuleList) === null || _e === void 0 ? void 0 : _e.find(x => x.Value === currentUnitValue)) === null || _f === void 0 ? void 0 : _f.ValueName;
                        if (currentUnitText) {
                            componentDraft.unit = currentUnitText;
                        }
                    }
                }
                const component = (0, immer_1.finishDraft)(componentDraft);
                components.push(component);
                break;
            }
            case trade_1.BuyUITypeEnum.Group: {
                const component = {
                    type: component_1.ComponentType.Group,
                    name: renderUnit.key,
                    key: renderUnit.key,
                    label: renderUnit.extra.groupName,
                    description: renderUnit.description,
                    isField: false,
                    isCalculable: false,
                    visible: renderUnit.echo,
                };
                components.push(component);
                break;
            }
            case trade_1.BuyUITypeEnum.SpuMeta: {
                const component = {
                    type: component_1.ComponentType.SpuMeta,
                    name: renderUnit.key,
                    key: renderUnit.key,
                    label: renderUnit.extra.spuMetaName,
                    text: renderUnit.extra.spuMetaText,
                    description: renderUnit.description,
                    isField: false,
                    isCalculable: false,
                    visible: renderUnit.echo,
                };
                components.push(component);
                break;
            }
            default: {
                (0, assert_never_1.default)(renderUnit);
            }
        }
    }
    return components;
};
exports.componentBuilderFactory = componentBuilderFactory;
function revertToEmptyComponent(component) {
    const emptyComponent = {
        name: component.name,
        key: component.key,
        label: component.label,
        type: component_1.ComponentType.Empty,
        isField: component.isField,
        isCalculable: component.isCalculable,
        description: component.description,
        valueType: component.valueType,
        unit: component.unit,
        isRequired: component.isRequired,
        isStatic: component.isStatic,
        isComputed: component.isComputed,
        defaultValue: component.defaultValue,
        defaultValueCalculator: component.defaultValueCalculator,
    };
    // eslint-disable-next-line no-param-reassign
    component.type = component_1.ComponentType.Empty;
    const keys = Object.keys(emptyComponent);
    // delete other properties
    for (const key of Object.keys(component)) {
        if (!keys.includes(key)) {
            // eslint-disable-next-line no-param-reassign
            delete component[key];
        }
    }
    return emptyComponent;
}
exports.revertToEmptyComponent = revertToEmptyComponent;
